/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('flow', [
  'countDataPoints',
]);


function countDataPoints(query) {
  return createAPIAction(
    types.countDataPoints,
    {
      endpoint: '/lora/dps/count',
      query,
    },
  )();
}

export default {
  countDataPoints,
};




// WEBPACK FOOTER //
// ./src/redux/actions/datapoint.js